export default __webpack_public_path__ + "static/3_months-f6801a9b36f30bbc11432997de3365ed.jpeg";